import {generateid} from '@/utils/commonUtils'

//const satelliteImg = require('@@/utils/resources/img/Satellite-07.png');
//const groundStationImg = require('@@/utils/resources/img/ppi_bl.png');

export function convertDDToDMS(D, lng) {
    return D !== null ? {
        dir: D < 0 ? lng ? 'W' : 'S' : lng ? 'E' : 'N',
        deg: 0 | (D < 0 ? D = -D : D),
        min: 0 | D % 1 * 60,
        sec: (0 | D * 60 % 1 * 60)
    } : null;
}

export function addViewerEventListener(viewer, eventType, callback) {
    viewer.canvas.addEventListener(eventType, e => {
        const ellipsoid = viewer.scene.globe.ellipsoid;
        const cartesian = viewer.camera.pickEllipsoid(new Cesium.Cartesian2(e.clientX, e.clientY), ellipsoid);
        let lng = null;
        let lat = null;
        if (cartesian) {
            const cartographic = ellipsoid.cartesianToCartographic(cartesian);
            lng = Cesium.Math.toDegrees(cartographic.longitude);
            lat = Cesium.Math.toDegrees(cartographic.latitude);
        }
        callback(lng, lat);
    }, false);
}

export function createPointGeoJson(lat, lng) {
    return {
        "type": "Feature",
        "properties":{},
        "geometry": {
            "type": "Point",
            "coordinates": [lat, lng]
        }
    }
}

export function createRectangleGeoJson(point1, point2) {
    return {
        "type": "Feature",
        "properties":{},
        "geometry": {
            "type": "Polygon",
            "coordinates": [[[point1.lat, point1.lng], [point2.lat, point1.lng], [point2.lat, point2.lng], [point1.lat, point2.lng], [point1.lat, point1.lng]]]
        }
    }
}

export function createSatellitePathCzml(position, labelText, color, leadTime, trailTime, id, startTime) {
    return {
        billboard: {
            eyeOffset: {
                cartesian: [0, 0, 0]
            },
            horizontalOrigin: "CENTER",
            image: satelliteImg,
            pixelOffset: {
                cartesian2: [0, 0]
            },
            scale: 0.5,
            show: true,
            verticalOrigin: 'CENTER',
            color: {
                rgba: color
            }
        },
        label: {
            fillColor: {
                rgba: [255, 255, 255, 255]
            },
            font: "11pt Lucida Console",
            horizontalOrigin: "LEFT",
            outlineColor: {
                rgba: [0, 0, 0, 255]
            },
            outlineWidth: 1,
            pixelOffset: {
                cartesian2: [16, 0]
            },
            show: true,
            style: "FILL_AND_OUTLINE",
            text: labelText,
            verticalOrigin: "CENTER"
        },
        path: {
            show: true,
            width: 1.0,
            material: {
                solidColor: {
                    color: {
                        rgba: color
                    }
                }
            },
            resolution: 60.0,
            leadTime: [{
                number: leadTime
            }],
            trailTime: [{
                number: trailTime
            }]
        },
        position: {
            cartesian: position,
            epoch: timeToISO8061(startTime),
            referenceFrame: "INERTIAL",
            interpolationAlgorithm: "LINEAR",
            interpolationDegree: 1
        },
        id
    }
}

export function createGroundTrackCzml(position, leadTime, trailTime, id, startTime) {
    return {
        path: {
            show: true,
            width: 1.0,
            material: {
                polylineGlow: {
                    color: {
                        rgba: [255,255,255,255]
                    }
                }
            },
            resolution: 60.0,
            leadTime: [{
                number: leadTime
            }],
            trailTime: [{
                number: trailTime
            }]
        },
        position: {
            cartographicRadians: position,
            epoch: timeToISO8061(startTime)
        },
        id
    }
}

export function createSightingAngleCzml(v1, v2, v3, id, startTime) {

    const epoch = timeToISO8061(startTime);

    const gId = generateid();

    return [{
        id,
        polygon: {
            positions: {
                references: [
                    gId + "-v1#position",
                    gId + "-v2#position",
                    gId + "-v3#position"
                ]
            },
            perPositionHeight: true,
            fill: false,
            outline: true,
            outlineWidth: 7.0,
            outlineColor: {
                rgba: [255, 255, 0, 255]
            }
        }
    },
        {
            id: gId + "-v1",
            position: {
                interpolationAlgorithm: "LAGRANGE",
                interpolationDegree: 1,
                epoch,
                cartographicDegrees: v1
            }
        },
        {
            id: gId + "-v2",
            position: {
                interpolationAlgorithm: "LAGRANGE",
                interpolationDegree: 1,
                epoch,
                cartographicDegrees: v2
            }
        },
        {
            id: gId + "-v3",
            position: {
                interpolationAlgorithm: "LAGRANGE",
                interpolationDegree: 1,
                epoch,
                cartographicDegrees: v3
            }
        }
    ]
}

export function createLaneCzml(v, id, startTime) {

    const epoch = timeToISO8061(startTime);

    const gId = generateid();

    const references = [];

    for (let i = 0; i < v.length; i++)
        references.push(gId + "-v" + i + "#position");


    const czml = [{
        id,
        polygon: {
            positions: {
                references
            },
            perPositionHeight: true,
            fill: false,
            outline: true,
            outlineWidth: 7.0,
            outlineColor: {
                rgba: [0, 255, 0, 255]
            }
        }
    }
    ];

    for (let i = 0; i < v.length; i++)
        czml.push({
            id: gId + "-v" + i,
            position: {
                interpolationAlgorithm: "LAGRANGE",
                interpolationDegree: 1,
                epoch,
                cartographicDegrees: v[i]
            }
        },)


    return czml;
}

export function createGroundStationCzml(longitude, latitude, altitude, labelText, id) {
    return {
        id,
        billboard: {
            image: groundStationImg,
            scale: 0.5
        },
        label: {
            fillColor: {
                rgba: [42, 177, 229, 255]
            },
            font: "11pt Lucida Console",
            horizontalOrigin: "LEFT",
            pixelOffset: {
                cartesian2: [25, 0]
            },
            style: "FILL",
            text: labelText
        },
        position: {
            cartographicDegrees: [longitude, latitude, altitude]
        }
    }
}

export function timeToISO8061(milliseconds) {
    return new Date(milliseconds).toISOString().replace(new RegExp('.\\d\\d\\dZ'), "Z");
}
